import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

export function DataCard({
  title,
  subtitle,
  children,
  actions,
  className,
  headerClassName,
  bodyClassName,
  delay = 0,
  onClick,
  ...rest
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
      onClick={onClick}
      {...rest}
      className={cn(
        'bg-white dark:bg-slate-900',
        'rounded-2xl border border-slate-200/60 dark:border-slate-800',
        'shadow-soft hover:shadow-soft-lg',
        'transition-all duration-300',
        'overflow-hidden',
        className
      )}
    >
      {(title || actions) && (
        <div
          className={cn(
            'px-6 py-4 border-b border-slate-200/60 dark:border-slate-800',
            'flex items-center justify-between',
            headerClassName
          )}
        >
          <div>
            {title && (
              <h3 className="text-lg font-heading font-semibold text-foreground">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={cn('p-6', bodyClassName)}>{children}</div>
    </motion.div>
  );
}
